module.exports = __webpack_public_path__ + "media/assets/images/vertical-blog-644cb1761015dc2d7aa413096cd95b0d.svg";